import React from "react";
import "./Loader.scss";
import { ReactComponent as LaurelWreath } from "../../../../assets/svg/Laurel.svg";

// `inline` renders the pulsing laurel centered within its container (no
// full-screen dark overlay) - for in-place loading states like the data grid.
const Loader = ({ inline = false }) => {
  return (
    <div className={inline ? "loader-inline" : "loader"}>
      <LaurelWreath className="laurel-wreath" />
    </div>
  );
};

export default Loader;
